// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"4d3b2235","81":"e1c9233f","315":"fb086a90","335":"61726e77","527":"544c3026","787":"ab75545b","815":"ec1b6782","951":"8ffbdfec"}[chunkId] + ".chunk.js";
};